import { Box, Text, UnorderedList, ListItem } from "@chakra-ui/react";
import background from "../assets/bg.jpg"
import Menubar from "../components/Menubar";
import { ACCENT_1_COLOR } from "../constants/color";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

export default function OurDojos() {
  const {t} = useTranslation();
  return (
    <Box display={"flex"} minH={"100vh"} width={"100vw"} background={`transparent url(${background})`}>
      <Helmet>
        <title>{t("ourDojosTitle")}</title>
        <meta name="description" content={t("ourDojosDesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/our-dojos" />
      </Helmet>
      <Box width={"100vw"}>
        <Menubar/>
        <Box width={"100vw"} px={{ base: "5vw", lg: "20vw" }} height={"100px"} display={"flex"} flexDir={"column"} textAlign={"left"} mt={"18px"}>
            <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>{t("dojoTitle")}</Text>
            <Text textColor={"#765946"} fontStyle={"italic"} fontSize={"18px"} mb={"24px"}>{t("dojoSubtitle")}</Text>
            <Text mb={"12px"}>{t("dojoDesc")}</Text>
            <Text mb={"12px"}>{t("dojoDesc2")}</Text>
            <Text mb={"12px"}>{t("dojoDesc3")}</Text>

            <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>{t("eastJava")}</Text>
            <UnorderedList ml={"36px"} mb={"12px"}>
                <ListItem>Dojo {t("malang")}</ListItem>
                <ListItem>Dojo {t("surabaya")}</ListItem>
                <ListItem>Dojo {t("sidoarjo")}</ListItem>
            </UnorderedList>
            <Text mb={"12px"}>{t("dojoDesc4")}</Text>
        </Box>
      </Box>
    </Box>
  );
}
